export function prefixFormatted(nombrePrestador) {
    const inicioCorchetes = nombrePrestador.indexOf('[');
    const finCorchetes = nombrePrestador.indexOf(']');
    const contenidoEntreCorchetes = nombrePrestador.slice(inicioCorchetes + 1, finCorchetes);

    return contenidoEntreCorchetes;
}

export function nameFormatted(nombrePrestador) {

    let nombreFormateadoFinal = nombrePrestador;

    if (nombreFormateadoFinal.includes('[') && nombreFormateadoFinal.includes(']')) {
        const inicioCorchetes = nombreFormateadoFinal.indexOf('[');
        const finCorchetes = nombreFormateadoFinal.indexOf(']');

        nombreFormateadoFinal = nombreFormateadoFinal.slice(0, inicioCorchetes) + nombreFormateadoFinal.slice(finCorchetes + 1);
    }

    if (nombreFormateadoFinal.includes(',')) {
        nombreFormateadoFinal = nombreFormateadoFinal.replace(',', '');
    }

    const nombresYApellidos = nombreFormateadoFinal.split(' ').filter(nombreYApellido => nombreYApellido !== '');

    nombreFormateadoFinal = nombresYApellidos.map(nombreYApellido => nombreYApellido.toUpperCase()).join(' ');

    return nombreFormateadoFinal;

}